"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NHSClaimMessageType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var NHSClaimMessageType_Factory = /** @class */ (function () {
    function NHSClaimMessageType_Factory() {
    }
    NHSClaimMessageType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            ClaimTypeID: model.ClaimTypeID,
            EDIType: model.EDIType,
            TypeDescription: model.TypeDescription,
        };
        return result;
    };
    NHSClaimMessageType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            ClaimTypeID: model.ClaimTypeID,
            EDIType: model.EDIType,
            TypeDescription: model.TypeDescription,
        };
        return result;
    };
    return NHSClaimMessageType_Factory;
}());
exports.NHSClaimMessageType_Factory = NHSClaimMessageType_Factory;
